import makeStyles from "@mui/styles/makeStyles";

export const useStyles = makeStyles((theme) => ({
  showButton: {
    width: 20,
    height: 20,
    margin: 0,
    padding: 0,
    border: 0,
    background: "transparent",
    outline: 0,
    color: theme.palette.grey[600],
    cursor: "pointer",
    "& > *": {
      fontSize: 20,
    },
    "&:focus": {
      color: theme.palette.primary.main,
    },
  },
}));
